export const formatCurrency = (amount: number, regionCode?: string): string => {
  let locale = 'en-GB';
  let currency = 'GBP';

  switch (regionCode?.toUpperCase()) {
    case 'US':
      locale = 'en-US';
      currency = 'USD';
      break;
    case 'EU':
      locale = 'en-IE';
      currency = 'EUR';
      break;
    case 'AU':
      locale = 'en-AU';
      currency = 'AUD';
      break;
    case 'UK':
    case 'GB':
    default:
      locale = 'en-GB';
      currency = 'GBP';
      break;
  }

  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
};
